module.exports = __webpack_public_path__ + "img/tech4.5c45db79.jpg";